<template>
  <div class="guestbook">
    <div class="guestbook-entry-button-container-new">
      <v-btn
        v-if="!newEntry"
        x-large
        color="hsla(193, 100%, 55%, 0.7)"
        elevation="5"
        class="guestbook-entry-button-new"
        @click.stop="newEntry = !newEntry"
        >Deinen Eintrag hinzufügen</v-btn
      >
      <v-card v-if="newEntry" class="mx-auto guestbook-entry-new" elevation="5">
        <v-card-title>
          <v-icon>
            person_add
          </v-icon>
          <v-text-field
            label="Dein Name"
            class="guestbook-entry-author"
            v-model="newEntryAuthor"
            :autofocus="newEntryAutofocusAuthor"
          />
        </v-card-title>

        <v-card-text class="body-1 guestbook-entry-text">
          <v-textarea
            label="Dein Text"
            hint="Wir freuen uns über deine Rückmeldung."
            auto-grow
            :autofocus="!newEntryAutofocusAuthor"
            v-model="newEntryText"
          />
          <div class="guestbook-entry-new-captcha-container">
            <img
              :src="newEntryCaptchaImage"
              v-if="newEntryCaptchaImage"
              alt="Captcha Picture"
            /><v-text-field
              v-model="newEntryCaptcha"
              label="Captcha"
              hint="Bitte den Text auf dem Bild abtippen."
              v-on:keypress="createOnEnter"
            />
          </div>
        </v-card-text>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row align="center" justify="start">
              <v-btn @click.stop="newEntry = !newEntry" text>Abbrechen</v-btn>
            </v-row>
            <v-row align="center" justify="end">
              <v-btn v-on:click="createNewEntry()" color="primary"
                >hinzufügen</v-btn
              >
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </div>
    <v-card
      v-for="(entry, i) in entries"
      :key="i"
      class="mx-auto guestbook-entry"
      elevation="5"
    >
      <v-card-title>
        <v-icon>
          person
        </v-icon>
        <span class="title guestbook-entry-author">{{ entry.author }}</span>
      </v-card-title>

      <v-card-text class="body-1 guestbook-entry-text">
        {{ entry.text }}
      </v-card-text>

      <v-card-actions>
        <v-list-item class="grow">
          <v-row align="center" justify="end">
            <span class="subheading">{{ entry.formattedDate }}</span>
          </v-row>
        </v-list-item>
      </v-card-actions>
    </v-card>
  </div>
</template>
<style scoped>
@media only screen and (orientation: portrait) {
  .guestbook {
    background-size: contain;
  }
}

@media only screen and (orientation: landscape) {
  .guestbook {
    background-size: cover;
  }
}

.guestbook {
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-image: url("hand-in-hand.jpg");
  background-position-x: center;
  background-repeat: repeat-y;
  background-attachment: fixed;
}
.guestbook-entry-button-container-new {
  flex-grow: 1;
  margin: 20px;
  width: 100%;
  max-width: 800px;
  padding-left: 10%;
  padding-right: 10%;
}
.guestbook-entry-button-new {
  flex-grow: 1;
  width: 100%;
}
.guestbook-entry-new {
  background-color: hsla(360, 100%, 100%, 0.7);
  transition: background 2s;
}
.guestbook-entry-new:hover {
  background-color: #ffffff;
}
.guestbook-entry-new-captcha-container {
  display: flex;
}
.guestbook-entry {
  flex-grow: 1;
  margin: 20px;
  width: 100%;
  max-width: 800px;
  color: #ffffff;
  background-color: hsla(193, 100%, 55%, 0.7);
  transition: background 2s;
}
.guestbook-entry:hover {
  background-color: hsla(193, 100%, 55%, 1);
}
.guestbook-entry-text {
  white-space: pre-line;
}
.guestbook-entry-author {
  padding-left: 10px;
}
</style>
<script>
import axios from "axios";
import moment from "moment";

moment.locale("de");

let hostName = process.env.VUE_APP_HOST_NAME
  ? process.env.VUE_APP_HOST_NAME
  : "";
const captchaImageUrl = `${hostName}api.php?route=guestbook/captcha`;

export default {
  name: "guestbook",
  data() {
    return {
      newEntry: false,
      newEntryAuthor: "",
      newEntryText: "",
      newEntryCaptcha: "",
      newEntryCaptchaImage: captchaImageUrl,
      newEntryAutofocusAuthor: true,
      entries: []
    };
  },
  methods: {
    createOnEnter: function(event) {
      if (event.keyCode === 13) {
        this.createNewEntry();
      }
    },
    createNewEntry: function() {
      axios
        .post(`${hostName}api.php?route=guestbook`, {
          author: this.newEntryAuthor,
          text: this.newEntryText,
          captcha: this.newEntryCaptcha
        })
        .then(({ data }) => {
          this.newEntryCaptcha = "";
          this.newEntryAutofocusAuthor = !this.newEntryAuthor;
          if (data.message) {
            // eslint-disable-next-line
            console.log(data);
            this.newEntryCaptchaImage = "";
            setTimeout(() => (this.newEntryCaptchaImage = captchaImageUrl));
          } else {
            this.newEntry = false;
            this.newEntryText = "";
            this.entries = [data, ...this.entries];
          }
        });
    }
  },
  mounted() {
    axios.get(`${hostName}api.php?route=guestbook`).then(
      response =>
        (this.entries = response.data.map(entry => ({
          ...entry,
          formattedDate: moment(entry.time).format("LLLL")
        })))
    );
  }
};
</script>
